import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const updatePayoutFrequencyConfigReq = (data: any, tokens: any) => {
  const { REACT_APP_CHANNEL_ID = '' } = window?._env_
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.addFreqConfig),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      entity: {
        initiatingEntityId: REACT_APP_CHANNEL_ID,
      },
      payoutFrequency: {
        startTime: data?.startTime ?? '',
        interval: Number(data?.interval ?? '0'),
        description: data?.description,
      },
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updatePayoutFrequencyConfigReq }
